import { Navigate, Route, Routes } from 'react-router';
import { PathManagement } from './pages/path-management';
import { EditPath } from './pages/path-management/pages/edit-path';
import { ShowPath } from './pages/show-path';
import { LearningPath } from '.';

export const LearningPathRoutes = () => {
  return (
    <Routes>
      <Route index path="/" element={<LearningPath />} />
      <Route path="/:pathId" element={<ShowPath />} />
      <Route path="*" element={<Navigate to="/trilhas" replace />} />
    </Routes>
  );
};

export const LearningPathManagementRoutes = () => {
  return (
    <Routes>
      <Route index path="/" element={<PathManagement />} />
      <Route path="/:pathId" element={<EditPath />} />
      <Route path="*" element={<Navigate to="/gestao-de-trilhas" replace />} />
    </Routes>
  );
};
